import script from "./Guard.vue?vue&type=script&setup=true&lang=ts"
export * from "./Guard.vue?vue&type=script&setup=true&lang=ts"

import "./Guard.vue?vue&type=style&index=0&id=27570c8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27570c8a"]])

export default __exports__